import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function CalendarIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        id="Group_3063"
        data-name="Group 3063"
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 20 20">
        <path id="Path_6542" data-name="Path 6542" d="M0,0H20V20H0Z" fill="none" />
        <path
          id="Path_6543"
          data-name="Path 6543"
          d="M14,2.6h3.2a.8.8,0,0,1,.8.8V16.2a.8.8,0,0,1-.8.8H2.8a.8.8,0,0,1-.8-.8V3.4a.8.8,0,0,1,.8-.8H6V1H7.6V2.6h4.8V1H14ZM16.4,9H3.6v6.4H16.4Zm-4-4.8H7.6V5.8H6V4.2H3.6V7.4H16.4V4.2H14V5.8H12.4ZM5.2,10.6H6.8v1.6H5.2Zm4,0h1.6v1.6H9.2Zm4,0h1.6v1.6H13.2Z"
          transform="translate(0 1)"
          fill="#4AB3BC"
        />
      </svg>
    </SvgIcon>
  );
}

export default CalendarIcon;
